import { Clock, Users, Video } from "lucide-react"

interface CourseMetadataProps {
	totalVideos: number
	hours: number
	totalStudents: number
}

export const CourseMetadata = ({ totalVideos, hours, totalStudents }: CourseMetadataProps) => {
	return (
		<div className="flex flex-wrap justify-center gap-3 text-muted-foreground text-xs sm:justify-start sm:text-sm">
			<div className="flex items-center gap-1">
				<Video className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
				<span>{totalVideos} video</span>
			</div>
			<div className="flex items-center gap-1">
				<Clock className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
				<span>{hours} giờ</span>
			</div>
			<div className="flex items-center gap-1">
				<Users className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
				<span>{totalStudents} người đăng ký</span>
			</div>
		</div>
	)
} 